import CloseIcon from '@mui/icons-material/Close';
import { Dialog, IconButton, SxProps, useMediaQuery } from '@mui/material';

import styles from './MinimizedHeader.module.scss';

interface Props {
    open?: boolean;
    onClose?: () => void;
}

export default function EarlyExitDialog({ open, onClose }: Props) {
    const isMobile = useMediaQuery('(max-width: 640px)');

    const positionStyleProps = {
        backgroundColor: '#fff',
        borderRadius: '0.5rem',
        maxHeight: isMobile ? '90%' : 'none',
        maxWidth: isMobile ? '90%' : '600px',
        position: 'fixed',
    } as SxProps;

    const sx = {
        '@media (max-width: 450px)': {
            '.MuiDialog-container': {
                alignItems: 'center',
            },
        },
    } as SxProps;

    return (
        <Dialog
            open={open}
            maxWidth="xs"
            onClose={onClose}
            BackdropProps={{ style: { backgroundColor: 'rgba(5, 51, 97, 0.56)' } }}
            PaperProps={{
                sx: {
                    ...positionStyleProps,
                },
            }}
            sx={sx}
            data-testid="early-exit-dialog">
            <IconButton
                aria-label="Close"
                className={styles['dialog-close-button']}
                onClick={onClose}>
                <CloseIcon />
            </IconButton>
            <hzn-stack align-x="center" space="medium" style={{ padding: '3rem' }}>
                <hzn-icon-warning class={styles['warning-icon']} />
                <hzn-heading align="center">Are you sure you want to leave?</hzn-heading>
                <hzn-text tone="subdued">
                    You&apos;ll need to re-enter payment types when you return.
                </hzn-text>
                <hzn-inline align-x="center">
                    <hzn-button
                        variant="tertiary"
                        onClick={() => onClose()}
                        data-testid="cancel-button">
                        Cancel
                    </hzn-button>
                    <hzn-button variant="cta" href="/" data-testid="continue-button">
                        Continue
                    </hzn-button>
                </hzn-inline>
            </hzn-stack>
        </Dialog>
    );
}
